import { ProColumns } from "@ant-design/pro-table"
import { Double, Ellipsis } from "@components/Common"
import { useDictEnumHooks, useHasAuthCode } from "@hooks/index"
import { StateType } from "@store/index"
import { amountFormat } from "@utils/index"
import { Button, Dropdown, Menu, Progress, Space, TreeSelect } from "antd"
import { stringify } from "qs"
import React from "react"
import { useSelector } from "react-redux"
import { Link } from "react-router-dom"
import { OperateActionType, StatusDot, TableListItem, signOptions, statusOptions, textOptions } from "../../data"
import { contractAuditStatus } from "@api/index"

const A = ({children, ...rest}: any) => <a {...rest}>{children}</a>

export const PurchaseContractOperate = ({record, type, operate}: any) => {
  const [, hasAuthCode] = useHasAuthCode()
  const Btn = type === 'primary' ? Button : A
  const style = { marginLeft: 10, whiteSpace: 'nowrap'} as any
  return ([
    (hasAuthCode(2447) && [1, -2, -4].includes(record?.status)) ? <Btn type={type} style={style} key="编辑采购合同" onClick={() => operate && operate('采购合同-编辑', record)}>编辑</Btn> : null,
    (hasAuthCode(2449) && [1].includes(record?.status)) ? <Btn type={type} style={style} key="撤销申请" onClick={() => operate && operate('采购合同-撤销申请', record)}>撤销申请</Btn> : null,
    (hasAuthCode(2450)) ? <Btn type={type} style={style} key="一键申请" onClick={() => operate && operate('采购合同-一键申请', record)}>一键申请</Btn> : null,
  ])
}

export const columnsFn: (operate: (type: OperateActionType, record?: any) => void, activeKey: any) => ProColumns<TableListItem>[] = (operate, activeKey) => {
    const { deptWithUserTreeData, cityTreeData, labelTreeData } = useSelector((state: StateType) => state)
    const [, , request] = useDictEnumHooks({}, false)
    const [, hasAuthCode] = useHasAuthCode()
  
    return [
      {
        title: '系统编号',
        dataIndex: 'sysNumber',
        order: 12,
        align: 'center',
      },
      {
        title: (_, type) => type === 'form' ? '合同编号' : '采购合同编号',
        dataIndex: 'cgContractNumber',
        fieldProps: { placeholder: '请输入采购合同编号'},
        order: 11,
        fixed: 'left',
        align: 'center',
        render: (text: any, record: any) => <Link to={`/finance/purchaseContractDetail?${stringify({contractId: record?.contractId, fromPath: '/finance/contract' })}`} >{record.cgContractNumber}</Link>
      },
      {
        title: (_, type) => type === 'form' ? '合同编号' : '销售合同编号',
        dataIndex: 'xsContractNumber',
        fieldProps: { placeholder: '请输入销售合同编号'},
        order: 10,
        align: 'center',
        render: (text: any, record: any) => <Link to={`/finance/saleContractDetail?${stringify({contractId: record?.xsContractId, fromPath: '/finance/contract' })}`} >{record.xsContractNumber}</Link>
        
      },
      {
        title: (_, type) => type === 'form' ? '合同名称' : '采购合同名称',
        dataIndex: 'cgContractName',
        fieldProps: { placeholder: '请输入采购合同名称'},
        order: 9,
        align: 'center',
        search: {
          transform: (contractName) => {
            return { contractName }
          },
        },
      },
      {
        title: '客户名称',
        dataIndex: 'customerName',
        order: 8,
        align: 'center',
      },
      {
        title: '供应商',
        dataIndex: 'supplier',
        order: 12,
        hideInSearch: true,
        align: 'center',
      },
      {
        title: '业务类型',
        dataIndex: 'businessTypes',
        order: 1,
        valueType: 'select',
        align: 'center',
        fieldProps: { mode: 'multiple' },
        params: { dictId: 269 },
        request,
        render: (text: any, record: any) => record.businessTypeStr
      },
      {
        title: (_, type) => type === 'form' ? '有无文本' : '有无文本合同',
        dataIndex: 'haveText',
        order: 3,
        align: 'center',
        fieldProps: { options: textOptions },
        valueType: 'select',
      },
      {
        title: (_, type) => type === 'form' ? '合同金额' : '合同金额(元)',
        dataIndex: 'contractAmount',
        order: 5,
        sorter: true,
        align: 'center',
        renderFormItem: (props) => <Double props1={{addonBefore: '¥'}} props2={{addonBefore: '¥'}} />,
        render: (text: any, record: any) => amountFormat(record.contractAmount),
        search: {
          transform: (contractAmounts) => {
            return { contractAmounts }
          },
        },
      },
      {
        title: '签约日期',
        dataIndex: 'signDate',
        sorter: true,
        hideInSearch: true,
        align: 'center',
      },
      {
        title: (_, type) => type === 'form' ? '是否盖章' : '合同是否盖章',
        dataIndex: 'whetherStamp',
        order: 2,
        align: 'center',
        fieldProps: { options: signOptions, placeholder: '请选择合同是否盖章'  },
        valueType: 'select',
      },
      {
        title: '备注',
        dataIndex: 'remark',
        // order: 8,
        hideInSearch: true,
        align: 'center',
        render: (text: any, record: any) => <div style={{width: 300, }}>{record.remark}</div>
      },
      {
        title: '审批状态',
        dataIndex: 'status',
        order: 16,
        align: 'center',
        fieldProps: { options: statusOptions, mode: 'multiple' },
        request: async () => {
          const { data } = await contractAuditStatus({type: 1}) as any
          return data||[]
        },
        valueType: 'select',
        // render: (text: any, record: any) => `${(record.statusStr||[]).toString()}`
        render: (text: any, record: any) => <><StatusDot status={record.status} />{`${(record.statusStr||[]).toString()}`}</>
      },
      {
        title: '提交人',
        dataIndex: 'creators',
        order: 7,
        fieldProps: {
          maxTagCount: 4,
          treeCheckable: true,
          showSearch: true,
          treeNodeFilterProp: 'title',
          treeData: deptWithUserTreeData
        },
        renderFormItem: (props) => <TreeSelect />,
        search: {
          transform: (ids) => {
            const creators = (ids||[]).map((v: string) => v.slice(1))
            return { creators }
          },
        },
        render: (text: any, record: any) => `${(record.creatorStr||[]).toString()}`
      },
      {
        title: '提交时间',
        dataIndex: 'createTime',
        valueType: 'dateRange',
        fieldProps: { allowEmpty: [true, true]},
        order: 4,
        align: 'center',
        sorter: true,
        search: {
          transform: (times) => {
            const startTime = times[0] ? `${times[0]} 00:00:00` : null
            const endTime = times[1] ? `${times[1]} 23:59:59` : null
            return {createTimes: [startTime, endTime]}
          },
        },
        render: (text: any, record: any) => `${record.createTime||''}`
      },
      {
        title: '当前审批人',
        dataIndex: 'currentAuditPersonStr',
        order: 6,
        fieldProps: {
          maxTagCount: 4,
          treeCheckable: true,
          showSearch: true,
          treeNodeFilterProp: 'title',
          treeData: deptWithUserTreeData
        },
        renderFormItem: (props) => <TreeSelect />,
        search: {
          transform: (ids) => {
            const currentAuditPersons = (ids||[]).map((v: string) => v.slice(1))
            return { currentAuditPersons }
          },
        },
      },
      {
        title: '操作',
        key: 'option',
        dataIndex: 'option',
        valueType: 'option',
        width: 120,
        fixed: 'right',
        // @ts-ignore
        render: (text: any, record: any) => <PurchaseContractOperate record={record} operate={operate} />,
      },
    ]
}